/**
 * Yakıt fişi hesapları (27.10.2026, #490). Sunucudaki YakitHesap.cs ile AYNI kural; sunucu kaydederken yeniden hesaplar ve
 * 1 kuruştan fazla fark varsa reddeder. Yuvarlama sıfırdan uzağa (0,005 yukarı), tutarlar 2, birim fiyat 4 ondalık.
 * - Netten (miktar / birim fiyat / KDV değişince): Net = Miktar × BirimFiyat, KDV = Net × oran, Brüt = Net + KDV.
 * - Brütten (brüt değişince): Net = Brüt / (1 + oran), KDV = Brüt − Net (kuruş farkı KDV'de kalır), BirimFiyat = Net / Miktar.
 */
export const HESAP_YONU = { NETTEN: 1, BRUTTEN: 2 };

export interface YakitSatirHesabi {
    net: number
    kdv: number
    brut: number
    birimFiyat: number
}

/** Sıfırdan uzağa yuvarlama; kayan nokta artığı (ör. 2,675 → 2,67499…) için küçük düzeltme. */
export const yuvarla = (deger: number, ondalik: number = 2): number => {
    const f = Math.pow(10, ondalik);
    return Math.sign(deger) * Math.round(Math.abs(deger) * f + 1e-9) / f;
}

export const netten = (miktar: number, birimFiyat: number, kdvOrani: number): YakitSatirHesabi => {
    const fiyat = yuvarla(birimFiyat, 4);
    const net = yuvarla(miktar * fiyat);
    const kdv = yuvarla(net * kdvOrani / 100);
    return { net, kdv, brut: yuvarla(net + kdv), birimFiyat: fiyat };
}

export const brutten = (miktar: number, brut: number, kdvOrani: number): YakitSatirHesabi => {
    const b = yuvarla(brut);
    const net = yuvarla(b / (1 + kdvOrani / 100));
    return { net, kdv: yuvarla(b - net), brut: b, birimFiyat: miktar > 0 ? yuvarla(net / miktar, 4) : 0 };
}

export const hesapla = (yon: number, miktar: number, birimFiyat: number, brut: number, kdvOrani: number): YakitSatirHesabi =>
    yon == HESAP_YONU.BRUTTEN ? brutten(miktar, brut, kdvOrani) : netten(miktar, birimFiyat, kdvOrani);

/** "1.234,56" → 1234,56 biçiminde gösterim (ondalık sayısı verilir). */
export const sayiYaz = (n: number | null | undefined, ondalik: number = 2): string =>
    n == null || isNaN(n) ? '' : n.toLocaleString('tr-TR', { minimumFractionDigits: ondalik, maximumFractionDigits: ondalik });

/** Birim fiyat: en az 2, en çok 4 ondalık ("52,349" → "52,349", "50" → "50,00"). */
export const fiyatYaz = (n: number | null | undefined): string =>
    n == null || isNaN(n) ? '' : n.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 4 });
